// Mobile Search JavaScript - Improved Version
document.addEventListener('DOMContentLoaded', function() {
  const searchTrigger = document.querySelector('[data-show-search-trigger]');
  const mobileSearch = document.querySelector('.mobile-search');
  const searchCloseButtons = document.querySelectorAll('[data-close-search]');
  const searchInput = document.querySelector('#mobile-search-input, .mobile-search input[name="q"]');
  const mobileHeader = document.querySelector('.mobile-header, #mobile-header');
  const body = document.body;
  let scrollPosition = 0;

  // Function to open mobile search
  function openMobileSearch() {
    if (mobileSearch) {
      // Store current scroll position
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      // Add classes
      mobileSearch.classList.add('is-visible');
      body.classList.add('mobile-search-open');
      
      // Hide mobile header
      if (mobileHeader) {
        mobileHeader.style.visibility = 'hidden';
        mobileHeader.style.zIndex = '1';
      }
      
      // Prevent body scroll
      body.style.position = 'fixed';
      body.style.top = `-${scrollPosition}px`;
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      
      // Focus on search input after animation
      setTimeout(() => {
        if (searchInput) {
          searchInput.focus();
          // On mobile, sometimes we need to trigger focus twice
          if (window.innerWidth <= 768) {
            setTimeout(() => searchInput.focus(), 100);
          }
        }
      }, 350);
    }
  }

  // Function to close mobile search
  function closeMobileSearch() {
    if (mobileSearch) {
      // Remove classes
      mobileSearch.classList.remove('is-visible');
      body.classList.remove('mobile-search-open');
      
      // Show mobile header
      if (mobileHeader) {
        mobileHeader.style.visibility = 'visible';
        mobileHeader.style.zIndex = '';
      }
      
      // Restore body scroll
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      body.style.overflow = '';
      
      // Restore scroll position
      window.scrollTo(0, scrollPosition);
      
      // Clear search input and blur focus
      if (searchInput) {
        searchInput.value = '';
        searchInput.blur();
      }
      
      // Clear any search results
      const searchResults = document.querySelector('.mobile-search .search__results');
      if (searchResults) {
        searchResults.innerHTML = '';
      }
    }
  }

  // Event listeners
  if (searchTrigger) {
    searchTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openMobileSearch();
    });

    // Also handle touch events for better mobile responsiveness
    searchTrigger.addEventListener('touchend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openMobileSearch();
    });
  }

  // Close search event listeners
  searchCloseButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileSearch();
    });

    button.addEventListener('touchend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileSearch();
    });
  });

  // Close search when clicking on backdrop (if any)
  if (mobileSearch) {
    mobileSearch.addEventListener('click', function(e) {
      // Only close if clicking directly on the mobile-search container
      if (e.target === mobileSearch) {
        closeMobileSearch();
      }
    });
  }

  // Close search on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileSearch && mobileSearch.classList.contains('is-visible')) {
      closeMobileSearch();
    }
  });

  // Handle search form submission
  const searchForm = document.querySelector('.mobile-search .search-form');
  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      const query = searchInput ? searchInput.value.trim() : '';
      if (!query) {
        e.preventDefault();
        return false;
      }
      // Let the form submit normally if there's a query
      // The search results page will load
    });
  }

  // Prevent zoom on iOS when focusing input
  if (searchInput && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
    searchInput.addEventListener('focus', function() {
      this.style.fontSize = '16px';
    });
    
    // Prevent rubber band scrolling on iOS
    searchInput.addEventListener('touchmove', function(e) {
      e.preventDefault();
    }, { passive: false });
  }

  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 799 && mobileSearch && mobileSearch.classList.contains('is-visible')) {
      closeMobileSearch();
    }
  });

  // Ensure proper cleanup if user navigates away
  window.addEventListener('beforeunload', function() {
    if (body.classList.contains('mobile-search-open')) {
      closeMobileSearch();
    }
  });
});

// Additional function to handle Searchanise integration
function initializeSearchanise() {
  const searchInput = document.querySelector('#mobile-search-input, .mobile-search input[name="q"]');
  
  if (typeof SnizeCore !== 'undefined' && searchInput) {
    try {
      // Configure Searchanise for mobile
      SnizeCore.initInput(searchInput, {
        mobileView: true,
        appendResultsTo: '.mobile-search .search__results',
        minChars: 2,
        delay: 300,
        maxResults: 10
      });
    } catch (error) {
      console.log('Searchanise initialization error:', error);
    }
  } else if (searchInput) {
    // Retry after a short delay if Searchanise isn't loaded yet
    setTimeout(initializeSearchanise, 200);
  }
}

// Initialize Searchanise when the page loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSearchanise);
} else {
  initializeSearchanise();
}